<template>
  <div class="single-select-choice relative">
    <el-select :placeholder="placeholder" v-model="issue.select" :filterable="issue.enableFilter" @change="$emit('change')">
      <el-option
          class="fixed-width-select"
          v-for="item in items"
          :key="item.id"
          style="max-width: 200px"
          :label="item.text"
          :value="item.id"
      />
    </el-select>
    <template v-if="selectItem && selectItem.is_other_item">
      <el-input v-model="selectItem.value" placeholder="请输入" class="mt-2"></el-input>
    </template>
    <div v-if="view" class="absolute inset-0 z-50"></div>

    <div class="vote-answer vote-answering-wrapper" v-if="showVoteProgress && changeExpr">
      <template v-if="voteItems.length">
        <div style="margin-bottom: 12px">
          投票排名
        </div>
      </template>
      <choice-vote-content :items="voteItems" />
      <template v-if="voteItems.length > 5">
        <el-button class="w-full" @click="onShowMoreRank">查看更多排名</el-button>
      </template>
    </div>
  </div>
</template>

<script>
import { transformRichText2Text } from 'dygc'
import selectVote from './select-vote'

export default {
  name: 'SingleSelectChoice',
  changeExpr: 'changeExpr',
  mixins:[selectVote],
  computed: {
    changeExpr() {
      let item = this.issue.getItemById(this.issue.select)
      if (item) {
        return item.id + item.value
      } else {
        return ''
      }
    },
    selectItem() {
      return this.issue.items.find(i => i.id === this.issue.select)
    },
    items() {
      return this.issue.items.map(item => {
        return {
          id: item.id,
          text: transformRichText2Text(item.content.richText)
        }
      })
    },
    placeholder() {
      return this.issue.placeholder || '请选择'
    }
  }
}
</script>

<style scoped></style>
